/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useState, useEffect } from 'react';
import { UsersListComp, Header } from '../components';
import { TweetyModal } from '@vlinder-web/tweety-modal-widget-react';
import { useTheme } from '../../../providers/theme';
import {
  useSMUsersListPageGetContent,
  useSMInviteUser,
  useSMDeleteUser,
  useSMReInviteUser,
  useSMSuspendUser,
  useSMActivateUser,
} from '../machines';
import { Paginate } from '@vlinder-web/paginate-widget-react';
import { NotificationModal } from '@vlinder-web/notification-modal-v2-widget-react';
import { vappContainer, VApplication } from '../../../application';
import toast from 'react-hot-toast';
import { SearchFilter } from '../../../widgets/filter-widget-react';
import { AdminPageService } from '../services';
import { StorageModule } from '@vlinder-web/storage-module-react';
import { Loader } from '@/components';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';
import { DetailedInfoCard } from '@/pages/UsersList/components/DetailedInfo';
import { AppNavigatorService } from '@/AppNavigator';

const getSrv = () => {
  return vappContainer.get<AdminPageService>(AdminPageService.displayName);
};

const getAppSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export const ContainerComm = (props: any) => {
  const theme = useTheme();
  const [showModal, setShowModal] = useState<boolean>(false);
  const [refreshPagination, setReFreshPagination] = useState(new Date());
  const staticPageContentConfig = getSrv()?.agent?.getStaticPageContentSync({});
  const srv = getSrv();
  const storageService = StorageModule.getInstance();

  const _sessionData = storageService.get('myProfile', 'session');
  const orgStatus = _sessionData?.org?.status;
  const { usersListPageSend, usersListPageState, usersListPageMachine } =
    useSMUsersListPageGetContent({});

  const { inviteUserMachine, inviteUserSend, inviteUserState } =
    useSMInviteUser({});

  const { deleteUserMachine, deleteUserSend, deleteUserState } =
    useSMDeleteUser({});
    const appSrv = getAppSrv();

  const { suspendUserMachine, suspendUserSend, suspendUserState } =
    useSMSuspendUser({});

  const { reInviteUserMachine, reInviteUserSend, reInviteUserState } =
    useSMReInviteUser({});

  const { activateUserMachine, activateUserSend, activateUserState } =
    useSMActivateUser({});

    const [whoAmI, setWhoAmI] = useState('');


  console.log('renderinvite user', inviteUserState?.event?.data?.value);
  const getWhoamI = async () => {
    const { whoami } = await appSrv.whoAmI();
    setWhoAmI(whoami);
  };

  useEffect(()=>{
    getWhoamI()
  },[])
  const _onHeaderDDActionItemClick = (id: string) => {};
  const onAddUser = (id: string) => {
    if (!showModal) {
      setShowModal(true);
    }
  };
  const onError = () => {
    //window.location.reload(false);
    usersListPageSend('TRIGGER_REFRESH', {});
  };

  const onModalClose = () => {
    if (showModal) {
      setShowModal(false);
    }
  };
  const onAddNewUser = (data: any) => {
    console.log(`org admin invite`, data);
    if (showModal) {
      setShowModal(false);
    }
    inviteUserSend('START', {
      payload: data,
    });
  };

  const onHeaderAction2Click = (id: string) => {
    if (id) {
      switch (id) {
        case 'import_users':
          toast.success('Coming soon!');
          // history.push(
          //   `${routesConfig?.routes?.UsersBatch?.path}`
          // );
          break;
        default:
          console.log(`unsupported header button id ${id} clicked`);
      }
    }
  };

  // const onAddNewUser = (
  //   email: string,
  //   firstName: string,
  //   lastName: string,
  //   invite: boolean
  // ) => {
  //   console.log(`on add new user `, email, firstName, lastName, invite);
  //   inviteUserSend("START", {
  //     payload: {
  //       email: email,
  //       firstName: firstName,
  //       lastName: lastName,
  //       invite: invite,
  //     },
  //   });
  // };

  const _addNewUser = () => {
    if (showModal) {
      return (
        // <NewUserModal
        //   showModal={showModal}
        //   onAcknowledgement={onAddNewUser}
        //   onDeny={onModalClose}
        // />
        <TweetyModal
          show={true}
          size={'lg'}
          scrollable={false}
          backdrop={'static'}
          submitButtonTitle={'Invite'}
          onSubmit={onAddNewUser}
          onHide={() => setShowModal(false)}
          title={'Invite Admin'}
          tweetyWidgetProps={{
            fields: staticPageContentConfig?.newUser?.FIELDS,
            layout: staticPageContentConfig?.newUser?.layout,
          }}
        />
      );
    }
  };

  const onRefresh = () => {
    usersListPageSend('TRIGGER_REFRESH', {});
    setReFreshPagination(new Date());
  };

  const onClearFilter = () => {
    Array.from(document.querySelectorAll('input')).forEach(
      (input) => (input.value = '')
    );
    usersListPageSend('TRIGGER_REFRESH', {});
  };

  const deleteUser = (id: any) => {
    console.log('deleteing user', id);
    deleteUserSend('START', {
      payload: id,
    });
    //toast.success("Coming soon!")
  };

  const onRemoveAdminAccess = (ids: any) => {
    suspendUserSend('START', {
      payload: ids,
    });
  };
  const onInviteUsers = (ids: any) => {
    // inviteUserSend("START", {
    //   payload: ids,
    // });
  };

  const onApplyFilter = (data: any, status: any) => {
    console.log(`on apply filter`, data);
    let criteria: any = [];
    if (data?.email) {
      criteria = [
        {
          column: 'email',
          op: 'Equal',
          value: data?.email,
        },
      ];
    }

    if (status) {
      criteria = [
        ...criteria,
        {
          column: 'accountStatus',
          op: 'Equal',
          value: status,
        },
      ];
    }
    usersListPageSend('TRIGGER_REFRESH', {
      where: criteria,
    });
  };

  const onTogglePress = (key: string, id: string) => {
    if (key === 'suspend') {
      suspendUserSend('START', {
        payload: id,
      });
    }
    if (key === 're-invite') {
      console.log('reinvite id', id);
      reInviteUserSend('START', {
        payload: id,
      });
    }
    if (key === 'activate') {
      activateUserSend('START', {
        payload: id,
      });
    }
  };

  const _renderSuspendNotification = () => {
    if (suspendUserState?.matches('SUSPEND_USER_SUCCESS')) {
      return (
        <>
          <NotificationModal
            showModal={true}
            {...(staticPageContentConfig?.notifications?.suspendUserSuccess ||
              {})}
            onAcknowledgement={onRefresh}
            onDeny={onRefresh}
          />
        </>
      );
    }
  };

  const _renderActivateNotification = () => {
    if (activateUserState?.matches('ACTIVATE_USER_SUCCESS')) {
      return (
        <>
          <NotificationModal
            showModal={true}
            {...(staticPageContentConfig?.notifications?.activateUserSuccess ||
              {})}
            onAcknowledgement={onRefresh}
            onDeny={onRefresh}
          />
        </>
      );
    }
  };

  const _renderDeleteNotification = () => {
    if (deleteUserState?.matches('DELETE_USER_SUCCESS')) {
      return (
        <>
          <NotificationModal
            showModal={true}
            {...(staticPageContentConfig?.notifications?.deleteUserSuccess ||
              {})}
            onAcknowledgement={onRefresh}
            onDeny={onRefresh}
          />
        </>
      );
    }
  };

  const _renderInviteNotification = () => {
    if (reInviteUserState?.matches('RE_INVITE_SUCCESS')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.notifications?.reInviteUser || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    if (inviteUserState?.matches('INVITE_USER_SUCCESS')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.notifications?.userInviteSuccess || {})}
          // description={[
          //   inviteUserState?.event?.data?.value,
          //   staticPageContentConfig?.notifications?.userInviteSuccess?.description[0],
          // ]}
          onAcknowledgement={onError}
          onDeny={onError}
        />
      );
    }
  };
  const _renderInviteSuccess = () =>{

  }
  const _renderPage = () => {
    if (
      usersListPageState?.matches('RENDER_PAGE') &&
      usersListPageState?.event?.data?.value
    ) {
      return (
        <>
          {usersListPageState?.event?.data?.value?.isEmpty ? (
            <StateOSD
              {...(staticPageContentConfig?.loading?.usersEmpty || {})}
            />
          ) : (
            <>
              <UsersListComp
                {...(usersListPageState?.event?.data?.value || {})}
                deleteItems={deleteUser}
                onRemoveAdminAccess={onRemoveAdminAccess}
                inviteUsers={onInviteUsers}
                onTogglePress={onTogglePress}
                onViewClick={props?.onViewClick}
                onRowClick={props?.onViewDetailClick}
              />
            </>
          )}
        </>
      );
    }
    
    if (usersListPageState?.matches('GET_PAGE_CONTENT')) {
      return (
        <Loader {...(staticPageContentConfig?.loading?.loadingUsers || {})} />
      );
    }
    return (
      <>
        {usersListPageState?.event?.data?.value?.isEmpty ? (
          <StateOSD {...(staticPageContentConfig?.loading?.usersEmpty || {})} />
        ) : (
          <UsersListComp
            // {...(usersListPageState?.event?.data?.value || {})}
            {...staticPageContentConfig?.sampleData}
            deleteItems={deleteUser}
            suspendItems={onRemoveAdminAccess}
            inviteUsers={onInviteUsers}
            onTogglePress={onTogglePress}
            onViewClick={props?.onViewClick}
            onRowClick={props?.onViewDetailClick}
          />
        )}
      </>
    );
  };

  const _renderHeader = () => {
    if (staticPageContentConfig?.header) {
      return (
        <>
          {(orgStatus && orgStatus === 'ACCEPTED' || whoAmI==='issuer') ? (
            <Header
              {...(staticPageContentConfig?.header || {})}
              onHeaderAction1Click={onAddUser}
              onHeaderDDActionItemClick={_onHeaderDDActionItemClick}
              onHeaderAction2Click={onHeaderAction2Click}
              onRefreshClick={onRefresh}
            />
          ) : (
            <Header {...(staticPageContentConfig?.header || {})} />
          )}
          <DetailedInfoCard
            isAdmin={true}
            {...(staticPageContentConfig?.settings || {})}
            onApplyFilter={onApplyFilter}
            onClearFilter={onClearFilter}
          />
          {/* <SettingsComp
            {...(staticPageContentConfig?.settings || {})}
            onApplyFilter={onApplyFilter}
            onClearFilter={onClearFilter}
          /> */}
        </>
      );
    }
    return null;
  };

  const onPaginationChange = (event: any) => {
    usersListPageSend('TRIGGER_REFRESH', {
      offset: event?.selected * 10,
      size: 10,
    });
  };

  const _renderPagination = () => {
    if (!usersListPageState?.event?.data?.value?.isEmpty) {
      return (
        <Paginate
          {...(usersListPageState?.event?.data?.value || {})}
          onPageChange={onPaginationChange}
          key={refreshPagination}
          totalItems={usersListPageState?.event?.data?.value?.ultUsers?.length}
        />
      );
    }
  };

  const _renderErrorModals = () => {
    if (usersListPageState?.matches('RENDER_PAGE_ERROR')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.getUsers || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    if (inviteUserState?.matches('INVITE_USER_FAILED')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.inviteUser || {})}
          description={[
            inviteUserState?.event?.data?.value,
            staticPageContentConfig?.error?.inviteUser?.description[1],
          ]}
          onAcknowledgement={onError}
          onDeny={onError}
        />
      );
    }
    
    if (deleteUserState?.matches('DELETE_USER_FAILED')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.deleteUser || {})}
          description={[
            deleteUserState?.event?.data?.value,
            staticPageContentConfig?.error?.deleteUser?.description[1],
          ]}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
  };
  const storageSrv = StorageModule?.getInstance();
  const userProfile = storageSrv.get('myProfile', 'session');
  const _renderStatus = () => {
    return (
      <Loader
        titleNormalText="Your organization is not approved yet"
        description={'Please contact your employer admin'}
      />
    );
  };

  const _renderSuspendError = () => {
    if (suspendUserState?.matches('SUSPEND_USER_FAILED')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.suspendUser || {})}
          description={[
            suspendUserState?.event?.data?.value,
            staticPageContentConfig?.error?.suspendUser?.description[1],
          ]}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    return null;
  };
  console.log('whoami->',whoAmI)
  const _renderActivateError = () => {
    if (activateUserState?.matches('ACTIVATE_USER_FAILED')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.activateUser || {})}
          description={[
            activateUserState?.event?.data?.value,
            staticPageContentConfig?.error?.activateUser?.description[1],
          ]}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
  };
  const _renderReInviteError = () => {
    if (reInviteUserState?.matches('RE_INVITE_FAILED')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.reinviteUser || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
  };

  const _renderLoading = () => {
    if (
      inviteUserState?.matches('INVITE_USER') ||
      reInviteUserState?.matches('RE_INVITE')
    ) {
      return (
        <Loader
          useModalLoader={true}
          {...(staticPageContentConfig?.loading?.inviteUser || {})}
        />
      );
    }
    if (
      suspendUserState?.matches('SUSPEND_USER') ||
      activateUserState?.matches('ACTIVATE_USER')
    ) {
      return (
        <Loader
          useModalLoader={true}
          {...(staticPageContentConfig?.loading?.suspendUser || {})}
        />
      );
    }

    if (deleteUserState?.matches('DELETE_USER')) {
      return (
        <Loader
          useModalLoader={true}
          {...(staticPageContentConfig?.loading?.deleteUser || {})}
        />
      );
    }
  };

  const _renderBody = () => {
    return (
      <>
        {_renderPage()}
        {_renderLoading()}
        {_renderPagination()}
        {_renderErrorModals()}
        {_addNewUser()}
        {_renderActivateError()}
        {_renderReInviteError()}
        {_renderSuspendError()}
        {_renderActivateNotification()}
        {_renderInviteNotification()}
        {_renderDeleteNotification()}
        {_renderSuspendNotification()}
      </>
    );
  };
  const _renderElseBody = () => {
    // if (whoAmI === "owner") {
    return (
      <StateOSD {...(staticPageContentConfig?.loading?.notAuthorized || {})} />
    );
    // }
    // else {
    //     return (
    //       <Loader {...(staticPageContentConfig?.loading?.applicationEmpty || {})} />
    //       );
  };

  return (
    <div>
      {/* <div style={{border : "1px solid red"}}> */}
      {_renderHeader()}
      {((orgStatus && orgStatus === 'ACCEPTED') || whoAmI==='issuer')
        ? _renderBody()
        : _renderElseBody()}

      {/* </div> */}
    </div>
  );
};
